/** The edit-destinations page for a trip. */
export const editTripDestinationsPath = (tripId: string | number): string =>
	`/trips/${tripId}/destinations`

/**
 * Router state the page reads to know where to return on save or close. Pass
 * it from an entry point that isn't the itinerary, the default way back.
 */
export interface EditTripDestinationsLocationState {
	returnTo?: string
}
